import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import scrollTo from 'gatsby-plugin-smoothscroll';

const IndexPage = ({data}) => (
  <Layout>
    <SEO title="Judges Have Enormous Power" keywords={[`Judicial`, `Elections`, `Philadelphia`]} />
    <p>You decide who becomes a judge in Pennsylvania. Make an informed decision in the upcoming elections using the following candidate ratings, which unless otherwise noted come from the Philadelphia Bar Association Commission on Judicial Selection and Retention. <a href="https://philadelphiabar.org/?pg=JudicialCommission">Judicial Commission</a>'s objective, nonpartisan investigations rate candidates on their ability, integrity and judgment.</p>
    <h1>2027 Ratings Coming in Spring 2027 </h1>
  
  </Layout>
)

export default IndexPage

export const query = graphql`
query {
  allJudges6Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges5Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges4Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges3Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges2Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges6Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges7Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudges8Json {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
  allJudgesJson {
    edges {
      node {
        name
        status
        ballotpos
      }
    }
  }
}
`